<template>
  <div class="flex flex-col overflow-hidden bg-base-100">
    <ThreadsNav>
      <template #left>
        <button class="btn btn-ghost" @click="clickBack">
          <i class="iconfont icon-left"></i>
        </button>
      </template>
      <template #center>
        <div></div>
      </template>
      <template #right>
        <button class="btn btn-sm rounded" @click="clickReset">
          {{ $t("Buttons.reset") }}
        </button>
        <button class="btn btn-primary btn-sm rounded" @click="clickConfirm">
          {{ $t("Buttons.confirm") }}
        </button>
      </template>
    </ThreadsNav>

    <div ref="allDom" class="flex overflow-auto">
      <Tree ref="treeList" :list="firstList" />
    </div>
    <Dialog
      v-model:show="managerStore.showEdit"
      :cancel-button-text="$t('Buttons.cancel')"
      :confirm-button-text="$t('Buttons.momentSave')"
      show-cancel-button
      @confirm="managerStore.confirmEdit"
    >
      <Field
        v-model="managerStore.editCache.displayText"
        :label="$t('Message.displayName')"
        :placeholder="$t('Message.enterDisplayName')"
        class="my-4"
      />
      <Field
        v-model="managerStore.editCache.text"
        :label="$t('Message.englishPrompt')"
        :placeholder="$t('Message.enterEnglishPrompt')"
        class="my-4"
      />
    </Dialog>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { usePrompts } from "@/stores/prompts";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { ref } from "vue";
import { usePromptManager } from "@/stores/manager";
import { Dialog, Field, showDialog } from "vant";
import Tree from "./Tree.vue";
import i18n from "@/locales";
import { useRouter } from "vue-router";

const treeList = ref<any>(null);

const promptStore = usePrompts();
const managerStore = usePromptManager();
const router = useRouter();

const firstList = ref<any[]>([]);
let tmpList = "";
const allDom = ref<any>(null);

const clickBack = () => {
  if (tmpList !== JSON.stringify(firstList.value)) {
    showDialog({
      title: i18n.global.t("ConfirmModal.notSaved"),
      message: i18n.global.t("ConfirmModal.confirmNotSave"),
      confirmButtonText: i18n.global.t("Buttons.confirm"),
      cancelButtonText: i18n.global.t("Buttons.cancel"),
      showCancelButton: true,
    })
      .then(() => router.back())
      .catch(() => {});
  } else {
    router.back();
  }
};

const clickConfirm = () => {
  showDialog({
    title: i18n.global.t("ConfirmModal.confirmTitle"),
    message: i18n.global.t("ConfirmModal.confirmSaveChanges"),
    confirmButtonText: i18n.global.t("Buttons.confirm"),
  })
    .then(() => managerStore.update(firstList.value, false))
    .catch(() => {});
};

const clickReset = () => {
  showDialog({
    title: i18n.global.t("ConfirmModal.confirmTitle"),
    message: i18n.global.t("ConfirmModal.confirmInit"),
    confirmButtonText: i18n.global.t("Buttons.confirm"),
  })
    .then(() => managerStore.update(firstList.value, true))
    .catch(() => {});
};

onMounted(async () => {
  await promptStore.getOrFetchImgPrompts();
  firstList.value = managerStore.FirstType.map(
    (item) => promptStore.promptId2Item[item]
  );
  tmpList = JSON.stringify(firstList.value);
  managerStore.allDom = allDom.value;
});
</script>
